import { Targeting as CarGurusTargeting, Targeting } from 'lib/GoogleAds';
import { MakeResponse } from 'types/MakeResponse';
import { LocationData } from 'lib/location/Geolocate';
import { FavoriteDataItem } from 'types/Apis/Favorites';
import { Lead } from 'types/Apis/Lead';
import { AutolistUser } from 'types/User';
import { ListItem } from 'types/TextSearch';
import SuggestiveSellingAdData from './SuggestiveSellingAdData';
import UtmTracking from './UtmTracking';
import FirstVisitTracking from './FirstVisitTracking';
import LeadParams from './Apis/LeadParams';
import { SrpFiltersState } from './srpFilters';

// Redux store state

export enum RequestStates {
  Unstarted = 'unstarted',
  Finished = 'finished',
  Requested = 'requested',
  Failed = 'failed',
}

export enum AlertTypes {
  Error = 'error',
  Success = 'success',
}

export interface Dialog {
  isShown: boolean;
}

export interface Alert {
  type: AlertTypes;
  message: string;
  uuid: string;
  debug?: string;
}

export interface Slot {
  isEmpty: boolean;
  isSuggestive: boolean;
  elementId: string;
}

export interface AdsSlice {
  adUnit: string | null;
  targeting: Targeting;
  slots: Slot[];
  suggestiveSellingAds: SuggestiveSellingAdData[];
}

export interface CarGurusAdsSlice {
  adUnit: string | null;
  targeting: CarGurusTargeting;
}

export interface SessionSlice {
  hasClosedAdhesionAd: boolean;
  isSignedIn: boolean | undefined;
  isPaid: boolean;
}

// https://redux.js.org/recipes/structuring-reducers/normalizing-state-shape
// We use byVin and allVins to allow for O(1) lookups and maintain order of the favorites
export interface FavoritesSlice {
  byVin: {
    [vin: string]: FavoriteDataItem;
  };
  allVins: string[];
  requestState: RequestStates;
  error?: string;
}

export interface LeadsSlice {
  leads: Lead[];
  error?: string;
}

export type LocationSlice = LocationData | null;

export interface TextSearchState {
  cursor: number | null;
  textInput: string;
  typedInput: string;
  list: ListItem[];
  dropDownOpen: boolean;
}

export default interface State {
  user: Partial<AutolistUser>;
  ads: AdsSlice;
  carGurusAds: CarGurusAdsSlice;
  makesAndModels: MakeResponse[];
  session: SessionSlice;
  favorites: FavoritesSlice;
  leads: LeadsSlice;
  leadSubmissions: LeadParams[];
  alerts: Alert[];
  geolocation: LocationSlice;
  dialog: {
    [name: string]: Dialog;
  };
  utmTracking: UtmTracking;
  firstVisitTracking: FirstVisitTracking;
  srpFilters: SrpFiltersState;
}
